import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CardDescription = ({ children }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      <Text type="bodyMRegular" color={theme.colors.text.muted}>
        {children}
      </Text>
    </Styles.Container>
  )
}

export default CardDescription
